export default __webpack_public_path__ + "static/media/icon2.a6c0e083.png";